// Framework and third-party non-ui
import React from 'react';

// App components
import PopoverMenu from './PopoverMenu';
import Reset from './Reset';

// JSON & Styles
import {
  StyledFilter,
} from './Filter-styled';

// Third-party components (buttons, icons, etc.)

const Filter = () => {

  return (
    <StyledFilter data-testid="Filter">
      <PopoverMenu type={'Trail Type'} aria-label="Trail Type Filter"/>
      <PopoverMenu type={'Activity Type'} aria-label="Activity Type Filter"/>
      <PopoverMenu type={'Difficulty'} aria-label="Difficulty Filter"/>
      <PopoverMenu type={'Length'} aria-label="Length Filter"/>
      <PopoverMenu type={'Suitability'} aria-label="Suitability Filter"/>
      <Reset aria-label="Reset All Filters"/>
    </StyledFilter>
  );
};

export default Filter;